export class WhatsAppOfficialConfiguracao {
  public id: number;
  public guidclientenapis: string;
  public nome_conexao: string;
  public provedor: string;
  public business_account_id: string;
  public phone_number_id: string;
  public numero_whatsapp: string;
  public access_token: string;
  public webhook_verify_token: string;
  public app_id: string;
  public app_secret: string;
  public webhook_url: string;
  public is_active: boolean;
  public created_at: Date;
  public updated_at: string;

  constructor() {
    this.provedor = "META";
    this.is_active = true;
  }
}
